export const SET_KIE_CONFIGURED = 'contentStudio/SET_KIE_CONFIGURED';

export const GENERATE_START = 'contentStudio/GENERATE_START';
export const TASK_CREATED = 'contentStudio/TASK_CREATED';
export const PROGRESS = 'contentStudio/PROGRESS';
export const COMPLETED = 'contentStudio/COMPLETED';
export const FAILED = 'contentStudio/FAILED';
export const CANCEL = 'contentStudio/CANCEL';
export const SET_CREDITS = 'contentStudio/SET_CREDITS';
